import { render, staticRenderFns } from "./DataAnnotations.vue?vue&type=template&id=6df0cbee"
import script from "./DataAnnotations.vue?vue&type=script&lang=js"
export * from "./DataAnnotations.vue?vue&type=script&lang=js"
import style0 from "./DataAnnotations.vue?vue&type=style&index=0&id=6df0cbee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports